import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const CalendlyPopup = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      const script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);

      // Prevent body scroll when popup is open
      document.body.style.overflow = 'hidden';

      return () => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
        document.body.style.overflow = 'auto';
      };
    }
  }, [isOpen]);

  // Wir nutzen den Link mit den Tracking-Parametern, passen aber Farben für das Dark-Theme an
  const calendlyUrl = "https://calendly.com/r-r-marketing/revenue-system-analyse?utm_source=skool&utm_medium=organic&utm_campaign=sales-system&utm_content=danke-page&hide_event_type_details=1&hide_gdpr_banner=1&background_color=0a0d14&text_color=ffffff&primary_color=2f6bff";

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center px-4 py-6 md:p-6">
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
          />
          
          <motion.div 
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            className="relative w-full max-w-4xl max-h-full bg-brand-dark rounded-2xl overflow-hidden shadow-[0_0_50px_rgba(47,107,255,0.15)] border border-brand-border flex flex-col"
          >
            <div className="flex justify-between items-center p-4 border-b border-brand-border bg-[#0a0d14]">
              <h3 className="text-white font-medium">Termin vereinbaren</h3>
              <button 
                onClick={onClose}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-white/5 hover:bg-white/10 text-gray-400 hover:text-white transition-colors"
              >
                <SafeIcon icon={FiX} className="text-lg" />
              </button>
            </div>
            
            <div className="flex-grow overflow-y-auto bg-[#0a0d14]">
              {/* Calendly Inline-Widget */}
              <div 
                className="calendly-inline-widget w-full" 
                data-url={calendlyUrl}
                style={{ minWidth: '320px', height: '700px' }}
              ></div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default CalendlyPopup;